import { Link } from "react-router-dom";
import { AlertCircle, ArrowLeft, MessageCircle } from "lucide-react";
import { BANK_INFO } from "@/data/services";

/**
 * TestPaymentPage — kept as a route for backwards compatibility, but the
 * card payment method is no longer offered. Shows a friendly notice with
 * the alternative payment channels.
 */
export default function TestPaymentPage() {
  return (
    <div className="min-h-screen pt-24 pb-16 px-4 sm:px-6" data-testid="test-payment-page">
      <div className="max-w-lg mx-auto">
        <Link
          to="/"
          data-testid="test-payment-back"
          className="inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-[#d4af37] mb-6"
        >
          <ArrowLeft className="w-4 h-4" /> Volver al inicio
        </Link>

        <div className="glass-dark border border-amber-500/30 rounded-2xl p-6 sm:p-8 text-center">
          <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-amber-500/15 border border-amber-500/40 flex items-center justify-center">
            <AlertCircle className="w-7 h-7 text-amber-300" />
          </div>
          <h1 className="font-serif text-2xl text-white mb-2">
            Pago con tarjeta no disponible
          </h1>
          <p className="text-sm text-neutral-300 leading-relaxed mb-6">
            Por el momento no aceptamos pagos con tarjeta en línea. Por favor usa uno
            de nuestros métodos de pago habituales — todos son seguros y confirmamos
            tu pago apenas nos llega el comprobante:
          </p>

          <ul className="text-left text-sm text-neutral-200 space-y-2 mb-6 max-w-sm mx-auto">
            <li className="flex items-start gap-2"><span className="text-[#d4af37]">•</span>Transferencia BBVA México (CLABE)</li>
            <li className="flex items-start gap-2"><span className="text-[#d4af37]">•</span>PayPal</li>
            <li className="flex items-start gap-2"><span className="text-[#d4af37]">•</span>Depósito en efectivo</li>
            <li className="flex items-start gap-2"><span className="text-[#d4af37]">•</span>Envío internacional (Wise, Remitly, Western Union, MoneyGram, Ria)</li>
            <li className="flex items-start gap-2"><span className="text-[#d4af37]">•</span>Retiro en ventanilla en Soriana (efectivo)</li>
          </ul>

          <div className="flex flex-col sm:flex-row gap-2 justify-center">
            <Link
              to="/mi-cuenta?tab=pays"
              data-testid="test-payment-go-pays"
              className="btn-gold px-5 py-2.5 rounded-full text-xs uppercase tracking-widest"
            >
              Ir a Mis Pagos
            </Link>
            <a
              href={BANK_INFO.whatsappLink}
              target="_blank"
              rel="noreferrer"
              data-testid="test-payment-whatsapp"
              className="btn-outline-gold px-5 py-2.5 rounded-full text-xs uppercase tracking-widest inline-flex items-center gap-2 justify-center"
            >
              <MessageCircle className="w-4 h-4" /> Escribir por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
